import React from 'react'
import classNames from 'classnames'
import Logo from '../common/Logo/Index'

const PushMenu = ({ isOpen, isMobile, children }) => {
  const classList = classNames({
    active: isOpen,
    'is-mobile': isMobile
  })

  const logoProps = {
    isOpen,
  }

  return (
    <div id="push-menu" className={classList}>
      <Logo {...logoProps} />
      {children}
    </div>
  )
}

export default PushMenu



// WEBPACK FOOTER //
// ./src/components/dashboard/PushMenu.js